export default __webpack_public_path__ + "static/li-71e3598cb0d8757085f8ef292039e0a8.svg";